import { CSSObject } from '@emotion/css'
import { tokens } from '@news-mono/design-tokens'
import { colors, Theme, themedValue } from '../..'
import { ChipVariant } from '../Chip/Chip'

/**
 * Returns Custom Styling for StyledTruncContainer based on passed styleName
 * @param variant chip variant to build CSS for
 * @param sharedStyling shared styling to be applied to all chips
 * @param theme theme to build styles from
 */

export function getChipCSS(
    variant: ChipVariant,
    sharedStyling: CSSObject,
    theme: Theme,
    buttonType?: string,
): CSSObject {
    switch (variant) {
        case 'pinned':
            return {
                ...sharedStyling,
                color: theme.colors.palette.white,
                backgroundColor: themedValue(theme, {
                    thewest: colors.thewest.breachNavy,
                    sevennews: colors.sevennews.darkRed,
                    fallback: theme.colors.brand,
                }),
            }
        case 'happening': {
            switch (buttonType) {
                case 'pink':
                    return {
                        ...sharedStyling,
                        color: theme.colors.palette.white,
                        backgroundColor:
                            tokens.sevennews.colors.palette.commonwealthGames
                                .hotMagenta,
                    }
                case 'purple':
                    return {
                        ...sharedStyling,
                        color: theme.colors.palette.white,
                        backgroundColor:
                            tokens.sevennews.colors.palette.commonwealthGames
                                .slateBlue,
                    }
                case 'orange':
                    return {
                        ...sharedStyling,
                        color: theme.colors.palette.black,
                        backgroundColor:
                            tokens.sevennews.colors.palette.commonwealthGames
                                .crayola,
                    }
                case 'blue':
                    return {
                        ...sharedStyling,
                        color: theme.colors.palette.black,
                        backgroundColor:
                            tokens.sevennews.colors.palette.commonwealthGames
                                .blueBolt,
                    }
                case 'green':
                    return {
                        ...sharedStyling,
                        color: theme.colors.palette.black,
                        backgroundColor:
                            tokens.sevennews.colors.palette.commonwealthGames
                                .bitterLemon,
                    }
                case 'Medal Moment':
                    return {
                        ...sharedStyling,
                        color: theme.colors.palette.white,
                        background:
                            'linear-gradient(299.44deg, #BD37AC 22.53%, #0E26C1 75.43%), #F1F1F1',
                    }
                case 'Gold Medal':
                    return {
                        ...sharedStyling,
                        color: theme.colors.palette.black,
                        background:
                            'linear-gradient(104.66deg, #FEE177 0.04%, #A5850E 90.14%), #F1F1F1',
                    }
                case 'Silver Medal':
                    return {
                        ...sharedStyling,
                        color: theme.colors.palette.black,
                        background:
                            'linear-gradient(98.41deg, #D8D8D8 -2.17%, #ACACAC 100.79%), #F1F1F1',
                    }

                case 'Bronze Medal':
                    return {
                        ...sharedStyling,
                        color: theme.colors.palette.black,
                        background:
                            'linear-gradient(98.91deg, #C48B68 5.91%, #A97142 79.24%), #F1F1F1',
                    }
                case 'Aussie Moment':
                    return {
                        ...sharedStyling,
                        color: theme.colors.palette.black,
                        background:
                            'linear-gradient(90.35deg, #FBE64D -12.69%, #F08031 74.62%), #DAF75C',
                    }
                case 'World Record':
                    return {
                        ...sharedStyling,
                        color: theme.colors.palette.black,
                        background:
                            'linear-gradient(91.42deg, #FD94C0 9.27%, #F7AA48 51.35%), linear-gradient(90.66deg, #FBE64D 11.14%, #F08031 109.05%), #F1F1F1',
                    }
                case 'Opening Ceremony':
                    return {
                        ...sharedStyling,
                        color: theme.colors.palette.white,
                        background:
                            'linear-gradient(292.86deg, #BD37AC 47.57%, #0E26C1 84.84%), linear-gradient(317.4deg, #BD37AC 29.33%, #0E26C1 85.95%), #F1F1F1',
                    }
                case 'Closing Ceremony':
                    return {
                        ...sharedStyling,
                        color: theme.colors.palette.white,
                        background:
                            'linear-gradient(92.45deg, #BD37AB 23.34%, #F08031 51.74%), linear-gradient(61.53deg, #B8F8B2 15.3%, #70FBF9 75.62%), linear-gradient(317.4deg, #BD37AC 29.33%, #0E26C1 85.95%), #F1F1F1',
                    }

                default:
                    return { ...sharedStyling }
            }
        }
        case 'label':
        default:
            return {
                ...sharedStyling,
                color: theme.colors.palette.white,
                backgroundColor: theme.colors.brand,
            }
    }
}
